import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MatTableDataSource, MAT_DIALOG_DATA } from '@angular/material';
import { ConfirmComponent } from 'src/app/components/confirm/confirm.component';
import { SoundEnum } from 'src/app/enums/sound.enum';
import { IConfirm } from 'src/app/interfaces/confirm';
import { SnackBarService } from 'src/app/services/common/snackBar.service';
import { SurveyService } from 'src/app/services/http/business/survey/survey.service';
import { SurQuestionAddComponent } from '../sur-question-add/sur-question-add.component';
import { SurQuestionEditComponent } from '../sur-question-edit/sur-question-edit.component';

@Component({
  selector: 'app-sur-question-list',
  templateUrl: './sur-question-list.component.html',
  styleUrls: ['./sur-question-list.component.css']
})
export class SurQuestionListComponent implements OnInit {

  displayedColumns: string[] = [
    'questionTypeName',
    'title',
    'activate',
    'function'
  ];

  dataSource = new MatTableDataSource();

  constructor(
    private surService: SurveyService,
    private dialog: MatDialog,
    private snackBar: SnackBarService,
    private dialogRef: MatDialogRef<SurQuestionListComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
    this.showQuestions(1, 100);
  }

  add() {
    this.dialog
      .open(SurQuestionAddComponent, {
        width: "350px",
        data: this.data
      }).afterClosed().subscribe(res => {
        if (res)
          this.showQuestions(1, 100);
      })
  }

  toggleState(data: any) {
    let confirm: IConfirm;
    if (data.IsActive) {
      confirm = {
        accept: true,
        message: 'آیا از غیر فعال کردن سوال اطمینان دارید؟',
        alert: null,
        yesLabel: 'بله',
        noLabel: 'خیر'
      };
    }
    else {
      confirm = {
        accept: true,
        message: 'آیا از فعال کردن سوال اطمینان دارید؟',
        alert: null,
        yesLabel: 'بله',
        noLabel: 'خیر'
      };
    }


    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.surService.surQuestionActiveDeactive({
          IsActive: !data.IsActive,
          Id: data.Id
        }).subscribe(
          () => {
            this.showQuestions(1, 100);
          },
          () => {
            this.snackBar.OpenSnackBar(
              "حذف با خطا مواجه شد",
              "ok",
              5000,
              SoundEnum.beep
            );
          }
        );
      }
    });
  }

  edit(data: any) {
    this.dialog
      .open(SurQuestionEditComponent, {
        width: "350px",
        data: data
      }).afterClosed().subscribe(res => {
        if (res)
          this.showQuestions(1, 100);
      })
  }


  delete(data: any) {
    let confirm: IConfirm = {
      accept: true,
      message: 'آیا از حذف سوال اطمینان دارید؟',
      alert: null,
      yesLabel: 'بله',
      noLabel: 'خیر'
    };

    const dialogRef = this.dialog.open(ConfirmComponent, {
      width: "250px",
      data: confirm
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.surService.surQuestionDelete(data).subscribe(
          () => {
            this.snackBar.OpenSnackBar(
              "حذف با موفقیت انجام شد",
              "ok",
              5000,
              SoundEnum.beep
            );
            this.showQuestions(1, 100);
          },
          () => {
            this.snackBar.OpenSnackBar(
              "حذف با خطا مواجه شد",
              "ok",
              5000,
              SoundEnum.beep
            );
          }
        );
      }
    });
  }

  showQuestions(page: number, pageSize: number) {
    this.surService.questionList({ QuestionCatId: this.data.Id }, page, pageSize).subscribe(res => {
      this.dataSource = new MatTableDataSource<any>(res.DataList);
    })
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

}
